export const CLASSNAME_PLACEHOLDER = 'field-placeholder'
export const CLASSNAME_HAS_VALUE = 'has-value'
export const CLASSNAME_INPUT = 'input'

export const STYLE_BOX_SHADOW_DEFAULT = '0px 2px 0 -1px #e5e5e5'
